export default class Notificacao {
  constructor(texto, titulo, tipo) {
    this.texto = texto;
    this.titulo = titulo;
    this.tipo = tipo;
  }
}
